import {commonConfig} from "./config";

export function makeId(len = 8) {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < len; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

export function debounce(func, delay) {
    let debounceTimer;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
    }
}

export function isValidEmail(email) {
    // Regular expression to validate an email address
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
}


export function formatBigNumber(number) {
    const abbreviations = ['K', 'M', 'G', 'T', 'P', 'E'];

    let base = 1000;
    let index = -1;

    while (number >= base && index < abbreviations.length - 1) {
        number /= base;
        index++;
    }

    // Проверяем, является ли число целым
    const formattedNumber = number % 1 === 0 ? number : number.toFixed(1);

    return formattedNumber + (index >= 0 ? abbreviations[index] : '');
}

export function isEmptyObject(obj) {
    return (obj === null || obj === undefined || Object.keys(obj).length === 0)
}

// The first region subtag among the browser's languages that names one of the OLX countries the page offers (all the
// site's by default), e.g. 'pl-PL' -> 'PL'. A country the page does not offer is skipped: picking it would leave the
// page without a selection. navigator.languages is the list the browser also sends as Accept-Language.
export function getOlxRegionFromBrowserLanguages(available = commonConfig.countries) {
    const languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (const language of languages) {
        const region = (language || '').split('-')[1];
        if (region && available.includes(region.toUpperCase())) {
            return region.toUpperCase();
        }
    }
    return null;
}

// `available`: the countries the page offers; the browser's region counts only among them.
export function getOlxRegionBasedOnLanguage(available = commonConfig.countries) {
    let userLang = document.documentElement.lang;
    userLang = userLang.toLowerCase();

    const browserRegion = getOlxRegionFromBrowserLanguages(available);

    const offsetMinutes = new Date().getTimezoneOffset();

    switch (userLang) {
        case 'pl':
        case 'pl-pl':
            return 'PL';
        case 'pt':
        case 'pt-pt':
            return 'PT';
        case 'bg':
        case 'bg-bg':
            return 'BG';
        case 'ro':
        case 'ro-ro':
            return 'RO';
        case 'uk':
        case 'uk-ua':
            return 'UA';
        case 'kk':
        case 'kk-kz':
            return 'KZ';
        case 'ru':
        case 'ru-ru':
            if (browserRegion) {
                return browserRegion;
            }
            if (offsetMinutes < -200) {
                return 'KZ'
            }
            return 'UA';
        default:
            return browserRegion || 'UA';
    }
}

export function formatNumberString(numberString) {
    const number = parseFloat(numberString);
    if (Number.isInteger(number)) {
        return number.toString();
    } else {
        return numberString;
    }
}

export function disableConsoleLogs() {

    if (process.env.NODE_ENV === 'production') {
        if (typeof console === "undefined") {
            window.console = {};
        }
        const methods = ["log", "debug"];
        for (let i = 0; i < methods.length; i++) {
            console[methods[i]] = function () {
            };
        }
    }

}

export function checkForCollapsibles() {
    let hasCollapsibles = false;
    $('.transform').each(function () {
        const targetId = $(this).attr('data-bs-target');
        const targetElement = $(targetId);
        if (targetElement.hasClass('show')) {
            hasCollapsibles = true;
            return false; // Прерываем цикл, если нашли открытый элемент
        }
    });
    return hasCollapsibles;
}


export function hasConsent(levels) {
    const cookie = document.cookie
        .split('; ')
        .find(row => row.startsWith('cookie_consent_level='));

    if (!cookie) {
        return false; // Если куки нет, согласие не предоставлено
    }

    try {
        const consentLevels = JSON.parse(decodeURIComponent(cookie.split('=')[1]));

        if (Array.isArray(levels)) {
            // Проверяем, чтобы все указанные уровни были разрешены
            return levels.every(level => consentLevels[level] === true);
        } else {
            // Проверяем согласие на один уровень
            return consentLevels[levels] === true;
        }
    } catch (error) {
        console.error('Error parsing cookie_consent_level:', error);
        return false; // При ошибке возвращаем отсутствие согласия
    }
}

const currencyToLocale = {
  UAH: 'uk-UA',   // украинская гривня
  PLN: 'pl-PL',   // польский злотый
  USD: 'en-US',
  EUR: 'pt-PT',
  BGN: 'bg-BG',
  KZT: 'kz-KZ',
};


export function formatMoney(amount, isoCode, opts = {}) {
  // Базовая локаль для валюты или «резерв» – браузерная по умолчанию
  const locale = currencyToLocale[isoCode] || undefined;

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: isoCode,
    ...opts          // можно передать {minimumFractionDigits: 0} и т.д.
  });

  return formatter.format(amount);
}

const SCHEMES = {
  'Visa':       d => d.startsWith('4'),
  'Mastercard': d => {
      const two   = parseInt(d.slice(0, 2), 10);
      const four  = parseInt(d.slice(0, 4), 10);
      return (two >= 51 && two <= 55) || (four >= 2221 && four <= 2720);
  },
  'Amex':       d => d.startsWith('34') || d.startsWith('37'),
  'Discover':   d => ['60','64','65'].some(p => d.startsWith(p)),
  'UnionPay':   d => d.startsWith('62'),
  'Diners':     d => ['30','36','38','39'].some(p => d.startsWith(p)),
  'JCB':        d => d.startsWith('35'),
  'Maestro':    d => ['50','56','57','58','6'].some(p => d.startsWith(p)),
};


export function detectScheme(maskedPan) {
  // Берём только цифры до первой звёздочки или вообще все, если звёздочек нет
  const digits = (maskedPan.match(/^\d+/) || [''])[0];
  for (const [name, rule] of Object.entries(SCHEMES)) {
    try {
      if (rule(digits)) return name;
    } catch {/*slice may overflow – игнорируем*/}
  }
  return null;
}
